import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobile_menu: false,
    token:'',
    login: false,
    center_code : '',
    center_name : '',
  },
  plugins: [createPersistedState()],
  mutations: {
    open_menu( state, tf ){
      state.mobile_menu = tf;
    },
    LOGIN(state, info) {
      state.token = info.token;
      state.login = true;
      state.center_code = info.center_code;
      state.center_name = info.center_name;
    },
    LOGOUT(state) {
      state.email = '';
      state.token = '';
      state.login = false;
      state.auth = [];
      state.color = '';
      state.center_code = '';
      state.center_name = '';
    },
  },
  actions: {
    SETLOGOUT ({commit}) {
      commit('LOGOUT')
    },
    SETLOGIN ({commit},info) {
      commit('LOGIN',info)
    },
  }
})
